import type { IIconContainerProps } from '@/components/atoms/IconContainer/IconContainer';
import type { LucideProps } from 'lucide-react';
import type { FunctionComponent } from 'react';
import { Check } from 'lucide-react';

import { IconContainer } from '@/components/atoms/IconContainer/IconContainer';
import { ctw } from '@/index';

export type ICheckCircle = {
  containerProps?: Omit<IIconContainerProps, 'children'>;
  size?: number;
} & Omit<LucideProps, 'size'>;

export const CheckCircle: FunctionComponent<ICheckCircle> = ({
  containerProps,
  size = 24,
  ...props
}) => {
  return (
    <IconContainer {...containerProps} size={size}>
      <Check {...props} size={size * 0.55} className={ctw('stroke-[4px]', props.className)} />
    </IconContainer>
  );
};
